<form class="noclass-forms" [formGroup]="noSessionForm">
  <p translate>teacher.reports.reason-label</p>
  <mat-form-field>
    <mat-select [formControl]="reasonCtrl" name="reason">
      <mat-option *ngFor="let reason of reasons" [value]="reason">
        <span translate>teacher.reports.{{reason.keyvalue}}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="abs_warning_msg" *ngIf="reasonCtrl.value.status=='abs_teacher_without_justification'"><span
      translate>teacher.reports.abs_teacher_warning_msg</span></div>
  <div class="abs_warning_msg" *ngIf="reasonCtrl.value.status=='abs_student_without_justification'"><span
      translate>teacher.reports.abs_student_warning_msg</span></div>

  <!-- Bloc upcoming-assigned importé depuis valid-session (lignes 50-90) -->
  @if (formation && formation.percent_exercice_rate > 0) {
  <div id="upcoming-assigned" *ngIf="formation && sheetPermission">
    <div class="form-subsec-title"><span translate>Total assigned exercises at this stage of the training</span></div>
  <app-progress-gauge class="progress-gauge" [formation]="formation" [extraShouldBeAssigned]="extraShouldBeAssigned"></app-progress-gauge>

    @if (isSheetLanguageAvailable) {
    <div class="form-subsec-title"><span translate>teacher.report.next_time_study_sheet</span></div>
    @if (formation && pending) {
    <app-exercice-assigned #onsiteAssigned [formationId]="formation.id" [typeExercice]="'onsite'" [session]="pending.session?.id"
      [reloadToken]="assignedReloadToken"
      (taskDeleted)="reloadExerciceDuration()" [canDeleteTask]="true"></app-exercice-assigned>
    }
    <div>
      <button type="button" class="assignsheet-btn" *ngIf="formation"
        (click)="openAssign('onsite','1')"><span>Assign a vocabulary exercices</span></button>
      <button type="button" class="assignsheet-btn" *ngIf="formation"
        (click)="openAssign('onsite','2')"><span>Assign a grammar exercices</span></button>
    </div>
    }
  </div>
  <!-- Fin bloc upcoming-assigned -->

  <!-- Bloc offsite exercices (importé de valid-session) -->
  <div id="upcoming-assigned" *ngIf="formation">
    <div class="form-subsec-title"><span translate>Exercices for next time</span></div>
    @if (formation && pending) {
    <app-exercice-assigned #offsiteAssigned [formationId]="formation.id" [typeExercice]="'offsite'" [session]="pending.session?.id"
      [reloadToken]="assignedReloadToken"
      (taskDeleted)="reloadExerciceDuration()" [canDeleteTask]="true"></app-exercice-assigned>
    }
  <button type="button" class="assignsheet-btn" (click)="openAssign('offsite')"><span>Assign a exercice offsite</span></button>
  </div>
  }


  <span translate>teacher.reports.additional-label</span>
  <textarea matInput [formControl]="detailsCtrl" name="details"></textarea>

  <div class="report-buttons-row">
    <button class="action-btn suboption" routerLink="../../../reports">
      <span translate>teacher.reports.complete-later-btn</span>
    </button>
    <button class="action-btn" type="submit" (click)="sendReport()" [disabled]="!reasonChange || !checkExerciceRate()">
      <span translate>teacher.reports.send-report-btn</span>
    </button>
    <div *ngIf="reasonChange && !checkExerciceRate()" class="error_msg">
      <span translate>You must complete the required exercise rate before proceeding.</span>
    </div>
  </div>
</form>

<!-- Modal d'assignation d'exercices -->
<app-modal *ngIf="showAssignModal" [componentToLoad]="componentToLoad" [componentName]="componentName" [modalParams]="modalParams" [allowClose]="true" (emitEvent)="handleModalEvent($event)"></app-modal>